const Images = {
  profileImage: require("./selfImage.png"),
  cv: require("./CV_Iris Wu (Pei-Yun, Wu).pdf"),
  project1: {
    mock1: require("./culturist-1.jpg"),
    mock2: require("./culturist-2.jpg"),
    mock3: require("./culturist-3.jpg"),
  },
  project2: {
    mock1: require("./stylish-1.jpg"),
    mock2: require("./stylish-2.jpg"),
    mock3: require("./stylish-3.jpg"),
  },
  project3: {
    mock1: require("./clima.jpg"),
  },
  project4: {
    mock1: require("./flashChat.jpg"),
  },
};
export default Images;
